import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useLocation } from "react-router-dom";
import ProfileHeader from "../../../components/ProfileHeader";
import DashboardApi from "../../../api/DashboardApi";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import { LinearProgress } from "@mui/material"; 
import {
  DataGridPremium,
  GridColDef,
  GridToolbarFilterButton,
  useGridRootProps,
  GridToolbarProps,
  GridToolbarContainer,
  esES,
} from "@asf-libs/x-data-grid-premium";
import ProfileContext from "../profile/ProfileContext";
import { Trans } from "react-i18next";
import {  USER_SO_KEY } from '../../../utils/accountUtils';
import { getSessionStorage } from '../../../utils/StorageUtil';

const statusTranslations: any = {
    "DISPONIBLE": "Disponible",
    "ALQUILADO": "Alquilado",
    "EN_REPARACION": "En Reparación",
    "DE_BAJA": "De Baja",
    "USO_PARTICULAR": "Uso Particular",
    "A_REVISAR": "A Revisar",
    "A_ENTREGAR": "A Entregar",
    "A_ASIGNAR": "A Asignar",
    "EN_TRANSLADO": "En Traslado",
    "EN_CONCESIONARIO": "En Concesionario",
    "EN_VENTA": "En Venta",
    "TRANSPORTE": "Transporte",
    "OPERATIVO_BASE": "Operativo Base",
    "DEVOLUCION_A_TERCEROS": "Devolución a Terceros"
}

export default function VehicleFleet() {
  const status = [
    "DISPONIBLE",
    "ALQUILADO",
    "EN_REPARACION",
    "USO_PARTICULAR",
    "UNIDADES_ALQUILADAS",
    "DE_BAJA",
  ];

  const notInStatus = [
    "DE_BAJA",
    "USO_PARTICULAR",
  ];

  const allStatus = [
    "DISPONIBLE",
    "ALQUILADO",
    "EN_REPARACION",
    "A_REVISAR",
    "A_ENTREGAR",
    "A_ASIGNAR",
    "EN_TRANSLADO",
    "EN_CONCESIONARIO",
    "EN_VENTA",
    "TRANSPORTE",
    "OPERATIVO_BASE",
    "USO_PARTICULAR",
    "DE_BAJA",
  ];

  const user = getSessionStorage(USER_SO_KEY);
  const location = useLocation();
  const statusToFilter = location.state;

  const [rows, setRows] = useState([]);
  const [filterModel, setFilterModel] = useState<any>({ items: [] });
  const [sortModel, setSortModel] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const filterInitialized = useRef(false);

  useEffect(() => {
    if (statusToFilter && !filterInitialized.current) {
      setFilterModel({
        items: [
          {
            field: "status",
            operator: "equals",
            value: statusTranslations[statusToFilter] || statusToFilter,
          },
        ],
      });
      filterInitialized.current = true;
    }
  }, [statusToFilter]);

const handleDownloadExcel = async () => {
  try {
    const params: any = {};
    filterModel?.items?.forEach((item: any) => {
        var key;
        if(item.operator === "isEmpty"){
            key = `${item.field}.`+"specified";
            params[key] = "false";
        }else if(item.operator === "isNotEmpty"){
            key = `${item.field}.`+"specified";
            params[key] = "true";
        }else{
            key = `${item.field}.${item.operator}`;
            params[key] = item.value;
        }
    });

    const isFilteringByExcludedStatus = filterModel?.items?.some(
      (item: any) =>
        item.field === "status" &&
        (item.value === "De Baja" || item.value === "Uso Particular")
    );
    if (!isFilteringByExcludedStatus) {
      params["status.notIn"] = notInStatus;
    }

    if (sortModel.length > 0) {
        const sortParam = `${sortModel[0].field},${sortModel[0].sort.toUpperCase()}`;
        params["sort"] = sortParam;
    }
      const response = await DashboardApi.generateVehicleExcel(params);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Vehiculos.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando Excel:", error);
    }
  };

  const getColumns = (role: any): GridColDef[] => {
    if (role === "RESPONSABLE_FLOTA" || role === "CHOFER") {
      return [
        {
          field: "numberPlate",
          headerName: "Dominio",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "brand",
          headerName: "Marca",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "model",
          headerName: "Modelo",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "status",
          headerName: "Estado",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
      ];
    } else if (
      role === "ADMINISTRATIVO" ||
      role === "DIRECTORIO" ||
      role === "LIDER_BASE"
    ) {
      return [
        {
          field: "numberPlate",
          headerName: "Dominio",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "brand",
          headerName: "Marca",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "model",
          headerName: "Modelo",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "base",
          headerName: "Base",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "status",
          headerName: "Estado",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "company",
          headerName: "Cliente",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "countStatusDays",
          headerName: "Cantidad de días",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
      ];
    } else {
      return [
        {
          field: "numberPlate",
          headerName: "Dominio",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "brand",
          headerName: "Marca",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "model",
          headerName: "Modelo",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "base",
          headerName: "Base",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "status",
          headerName: "Estado",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
        {
          field: "company",
          headerName: "Cliente",
          width: 150,
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          align: "center",
        },
      ];
    }
  };

  useEffect(() => {
    let active = true;

    (async () => {
      setLoading(true);
      try {
        const response = await DashboardApi.getVehicle();
        const dataRows = response?.data
          ?.filter((ca: any) => {
            return user?.role === "DIRECTORIO"
              ? allStatus.includes(ca.status)
              : status.includes(ca.status);
          })
          .map((d: any, index: number) => {
            const translatedStatus = statusTranslations[d.status] || d.status;
            return {
              id: index,
              numberPlate: d.numberPlate,
              brand: d.brand,
              model: d.model,
              base: d.base,
              status: translatedStatus,
              company: d.company,
              countStatusDays: d.countStatusDays,
            };
          });
        if (!active) return;
        setRows(dataRows || []);
      } catch (error) {
        console.error("Error cargando vehículos:", error);
      } finally {
        if (!active) return;
        setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [filterModel]);

  const CustomToolbar = React.forwardRef<HTMLDivElement, GridToolbarProps>(
    function GridToolbar(props, ref) {
      const rootProps = useGridRootProps();

      if (
        rootProps.disableColumnFilter &&
        rootProps.disableColumnSelector &&
        rootProps.disableDensitySelector
      ) {
        return null;
      }

      return (
        <GridToolbarContainer
          sx={{ background: "#F2F3F1", border: 0, width: "100%" }}
          ref={ref}
          {...props}
        >
          <Box className="indicators-title">
            <Trans i18nKey={`screens.indicators.titleList`}></Trans>

            <GridToolbarFilterButton sx={{ ml: 10 }} />
            <Tooltip title="Descargar Excel">
              <IconButton color="primary" onClick={handleDownloadExcel}>
                <FileDownloadIcon/>
              </IconButton>
            </Tooltip>
          </Box>
        </GridToolbarContainer>
      );
    }
  );

  return (
    <ProfileContext.Consumer>
      {(context) => {
        const userData = context.userData;
        return (
          <Box sx={{ background: "#F2F3F1" }}>
            <ProfileHeader />
            <Box sx={{ margin: "0 4%" }}>
              <Box
                borderRadius={5}
                sx={{
                  background: "#FFFFFF",
                  height: (rows?.length + 1) * 50 + 200,
                  pt: 1,
                }}
              >
                <DataGridPremium
                  localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                  rows={rows}
                  columns={getColumns(user.role)}
                  loading={loading}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  filterModel={filterModel}
                  onFilterModelChange={(newModel) => setFilterModel(newModel)}
                  sortModel={sortModel}
                  onSortModelChange={(newModelSort) => setSortModel(newModelSort)}
                  sx={{
                    border: 0,
                    "& .super-app-theme--header": {
                      fontWeight: "900",
                    },
                  }}
                />
              </Box>
            </Box>
            <ProfileBottomNav goBack={true} />
          </Box>
        );
      }}
    </ProfileContext.Consumer>
  );
}
